import {
  centsToDollars,
  centsToDollarsRaw,
  floatsOnly,
  isset,
} from "legacy/helpers.es6"
import RefundLanguage from "legacy/manage/RefundLanguage"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class ManualRefund extends React.Component {
  constructor(props) {
    super(props)

    const { originalPrice, updatedPrice, adjustments } = this.props

    const adjustmentNet = _.sumBy(adjustments, "amount")
    const adjustmentNetDollars = (adjustmentNet / 100).toFixed(2)

    if (isset(originalPrice)) {
      this.state = {
        originalPrice,
        updatedPrice,
        netPrice: updatedPrice - originalPrice,
        manualOverride: centsToDollarsRaw(
          Math.abs(updatedPrice - originalPrice)
        ),
        adjustmentNet,
        adjustmentNetDollars,
      }
    } else {
      this.state = {
        originalPrice: 0,
        updatedPrice: 0,
        netPrice: 0,
        manualOverride: 0,
        adjustmentNet,
        adjustmentNetDollars,
      }
    }

    // Bind methods to this
    this.updatePricingState = this.updatePricingState.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.showModal = this.showModal.bind(this)
    this.pricingLanguage = this.pricingLanguage.bind(this)
    this.updateRefundAmount = this.updateRefundAmount.bind(this)
    this.refundReason = this.refundReason.bind(this)
    this.isManualOverrideLess = this.isManualOverrideLess.bind(this)
    this.changeRefundDetails = this.changeRefundDetails.bind(this)
    this.defaultButtonClick = this.defaultButtonClick.bind(this)
    this.defaultButton = this.defaultButton.bind(this)
    this.submitText = this.submitText.bind(this)
    this.isDisabled = this.isDisabled.bind(this)
    this.refundForm = this.refundForm.bind(this)
    this.manualPaymentWarning = this.manualPaymentWarning.bind(this)
  }

  updatePricingState(originalPrice, updatedPrice) {
    if (!isset(this.state.modalShown) || this.state.modalShown === false) {
      this.setState({
        originalPrice,
        updatedPrice,
        netPrice: updatedPrice - originalPrice,
        manualOverride: centsToDollarsRaw(
          Math.abs(updatedPrice - originalPrice)
        ),
      })
    }
  }

  closeModal() {
    this.setState({ modalShown: false })
  }

  showModal() {
    this.setState({ modalShown: true })
  }

  pricingLanguage() {
    if (!this.props.usingCreditCard && !this.props.isScheduled) {
      return null
    }

    if (this.props.page === "edit") {
      return (
        <RefundLanguage
          state={this.state}
          status={this.props.status}
          autoBill={this.props.autoBill}
        />
      )
    } else {
      const additionalAdjustmentLanguage =
        this.state.adjustmentNetDollars === 0 ||
        this.state.adjustmentNetDollars === null
          ? null
          : ` There's an additional $${this.state.adjustmentNetDollars} reserved as an adjustment that you can also release by increasing the refund.`
      return (
        <div className="pricing-language">
          The amount below is the full refund. You can change this value to
          adjust the amount to refund the customer.
          {additionalAdjustmentLanguage}
        </div>
      )
    }
  }

  updateRefundAmount(event) {
    this.setState({ manualOverride: floatsOnly(event.target.value) })
  }

  refundReason() {
    const manualOverride = parseFloat(this.state.manualOverride)
    const maxRefundable =
      (Math.abs(this.state.netPrice) + this.state.adjustmentNet) / 100

    if (this.isManualOverrideLess() && manualOverride <= maxRefundable) {
      return (
        <div className="form-group">
          <div
            className="text-danger b text-center"
            style={{ marginBottom: "10px" }}
          >
            Please supply a reason for applying a different refund amount than
            suggested.
          </div>
          <textarea
            className="form-control"
            name="refund_details"
            value={this.state.refundDetails}
            onChange={this.changeRefundDetails}
          />
        </div>
      )
    } else if (manualOverride > maxRefundable) {
      return (
        <div
          className="text-danger b text-center"
          style={{ marginBottom: "10px" }}
        >
          You can not refund more than{" "}
          {centsToDollars(
            Math.abs(this.state.netPrice) + this.state.adjustmentNet
          )}
          .
        </div>
      )
    }
    return null
  }

  isManualOverrideLess() {
    return (
      parseFloat(this.state.manualOverride) !==
        parseFloat(centsToDollarsRaw(Math.abs(this.state.netPrice))) ||
      !isset(this.state.manualOverride)
    )
  }

  changeRefundDetails(event) {
    this.setState({ refundDetails: event.target.value })
  }

  defaultButtonClick() {
    this.setState({
      manualOverride: centsToDollarsRaw(Math.abs(this.state.netPrice)),
    })
  }

  defaultButton() {
    if (
      parseFloat(this.state.manualOverride) !==
      parseFloat(centsToDollarsRaw(Math.abs(this.state.netPrice)))
    ) {
      return (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.defaultButtonClick}
        >
          Reset Amount
        </button>
      )
    }
    return null
  }

  submitText() {
    if (this.props.page === "edit") {
      return "Update Reservation"
    } else if (
      this.props.page === "show" &&
      this.props.status === "confirmed"
    ) {
      return "Cancel Reservation"
    } else if (
      this.props.page === "show" &&
      this.props.status !== "confirmed"
    ) {
      return "Refund Reservation"
    } else {
      return "Submit"
    }
  }

  isDisabled() {
    if (
      parseFloat(this.state.manualOverride) >
      centsToDollarsRaw(
        Math.abs(this.state.netPrice) + this.state.adjustmentNet
      )
    ) {
      return true
    } else if (
      this.isManualOverrideLess() &&
      !isset(this.state.refundDetails)
    ) {
      return true
    } else {
      return false
    }
  }

  refundForm() {
    if (!this.props.usingCreditCard && !this.props.isScheduled) {
      return null
    }
    // show form if there's something to refund (even if just an adjustment)
    const hasRefundableBalance =
      this.state.originalPrice > this.state.updatedPrice ||
      (this.state.adjustmentNet > 0 &&
        this.state.originalPrice === this.state.updatedPrice)

    if (hasRefundableBalance && this.props.status !== "pending") {
      return (
        <div>
          <div
            className="refund-amount-wrapper form-group center"
            style={{ textWrap: "none" }}
          >
            <label className="center">Refund Amount</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-left">$</span>
              <input
                className="form-control"
                type="text"
                name="refund_dollar_amount"
                value={this.state.manualOverride}
                onChange={this.updateRefundAmount}
                autoComplete="off"
              />
            </div>
            {this.defaultButton()}
          </div>
          {this.refundReason()}
        </div>
      )
    } else {
      return (
        <div>
          <input
            className="hidden"
            type="text"
            name="refund_dollar_amount"
            value={0}
            autoComplete="off"
          />
        </div>
      )
    }
  }

  manualPaymentWarning() {
    if (!this.props.usingCreditCard && !this.props.isScheduled) {
      return (
        <div>
          Since this reservation is using manual payments, Dockwa will not
          automatically charge or refund changes to this reservation. Please
          make these edits manually on the reservation page.
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <div
        id="manual-refund"
        className={this.props.notInModal ? "paper-page" : null}
      >
        {this.manualPaymentWarning()}
        {this.pricingLanguage()}
        {this.refundForm()}
        <hr />
        <div className="clearfix">
          <div className="cancellation-policy float-left">
            Your marina&apos;s{" "}
            <a
              href={this.props.cancellationPolicy}
              target="_blank"
              rel="noopener noreferrer"
            >
              cancellation policy
            </a>
          </div>
          <button
            className="btn btn-primary load-and-disable float-right"
            type="submit"
            disabled={this.isDisabled()}
          >
            {this.submitText()}
          </button>
        </div>
      </div>
    )
  }
}

ManualRefund.propTypes = {
  originalPrice: PropTypes.number,
  updatedPrice: PropTypes.number,
  adjustments: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
    })
  ),
  usingCreditCard: PropTypes.bool,
  isScheduled: PropTypes.bool,
  page: PropTypes.string,
  status: PropTypes.string,
  autoBill: PropTypes.bool,
  notInModal: PropTypes.bool,
  cancellationPolicy: PropTypes.string,
}

ManualRefund.defaultProps = {
  adjustments: [],
}

export default ManualRefund
